import React from "react";
import {useFormContext} from 'react-hook-form'
import {emailRegex} from '../../utils'
import "./TextInput.css";

const getDefaultProps = (props) => {
    return {
        className: `afs-msm-text-input`,
        id: props.name,
        name: props.name,
        placeholder: props.placeholder,
        type: props.type,
        value: props.value,
        defaultValue: props.defaultValue,
        onChange: props.onChange
    };
};

const NonValidatedInput = (props) => {
    return (<input
        {...getDefaultProps(props)}
    />)
};

const ValidatedInput = (props) => {
    const {register} = useFormContext();
    const validation = props.type === 'email' && props.validation.required ? Object.assign({}, props.validation, {pattern: emailRegex}) : props.validation;
    return (<input
        ref={register(validation)}
        {...getDefaultProps(props)}
    />)
};

const Errors = (props) => {
    const {errors} = useFormContext();
    return (errors[props.name] &&
        <b className={`afs-msm-text-input-error`}>
            {props.errorText || errors[props.name].type}
        </b>) || null
};


export default props => {
    return (
        <div className={`afs-msm-text-input-holder ${props.name}`}>
            <label className={`afs-msm-text-input-label`} htmlFor={props.name}>
                {props.label}
            </label>
            {props.validation ? <ValidatedInput {...props}/> : <NonValidatedInput {...props}/>}
            {props.helper && (
                <span className={`afs-msm-text-input-helper`}>{props.helper}</span>
            )}
            {props.validation ? <Errors {...props}/> : null}
        </div>
    );
};
